const KEY = 'divine_data_v1';

const defaultData = {
  testimonials: [],
  categories: [],
  subcategories: [],
  products: [],
  caseStudies: [],
  posts: []
};

export function loadData() {
  try {
    const raw = localStorage.getItem(KEY);
    if (!raw) return { ...defaultData };
    const parsed = JSON.parse(raw);
    return { ...defaultData, ...parsed };
  } catch {
    return { ...defaultData };
  }
}

export function saveData(data) {
  localStorage.setItem(KEY, JSON.stringify(data));
}

export function uid() {
  return Math.random().toString(36).slice(2, 10);
}
